Postlogin = (function (my) {
    my.AdminLessonEdit = {};
    const self = my.AdminLessonEdit;

    self.init = function () {
        $('.document button.btn-remove').on('click', (e) => {
            e.preventDefault();

            const removeDocument = $(e.currentTarget).data('remove');
            const removeRequest = new VjsUtility.Request();

            removeRequest
                .delete(removeDocument)
                .done(() => {
                    const notificationOptions = {};

                    notificationOptions.title = 'Success';
                    notificationOptions.text = 'Removed Document';
                    notificationOptions.icon = 'fa-regular fa-circle-check';
                    notificationOptions.type = 'success';

                    VjsUtility.Notification.init(notificationOptions);

                    $(e.currentTarget)
                        .parent('.document')
                        .fadeOut('normal', function () {
                            $(this).remove();
                        });
                })
                .fail(() => {
                    const notificationOptions = {};

                    notificationOptions.title = 'Error';
                    notificationOptions.text = 'Failed to remove file';
                    notificationOptions.icon = 'fa fa-exclamation-triangle';
                    notificationOptions.type = 'error';

                    VjsUtility.Notification.init(notificationOptions);
                });
        });

        $('#add-document').on('click', (e) => {
            // add a file field
            e.preventDefault();
            const documentContainer = $('#lesson-documents');
            const documentNumber = documentContainer.find('.document-container').length + 1;

            const $documentField = `
                <div class="row document-container well well-lg">
                    <div class="col-lg-9">
                        <div class="input-group document-title">
                            <label id="title-input-label-${documentNumber}">Document Title:</label>
                            
                            <input id="lesson-document-${documentNumber}-title" name="lesson_document_${documentNumber}_title"
                            type="text" class="form-control" aria-describedby="title-input-label-${documentNumber}">
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="input-group document-type">
                            <label id="type-select-label-${documentNumber}">Outline</label>
                            <input id="lesson-document-${documentNumber}-type" name="lesson_document_${documentNumber}_type" value="outline"
                                type="checkbox" class="form-control" aria-describedby="type-select-label-${documentNumber}">
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <label for="lesson-document-${documentNumber}">File:</label>
                        <input type="file" class="form-control" aria-label="File" id="lesson-document-${documentNumber}" name="lesson_document_${documentNumber}">
                    </div>
                </div>
            `;

            documentContainer.append($documentField);
            const newField = $(`#lesson-document-${documentNumber}`);

            // set fileinput with individual field
            $(newField).fileinput({
                showUpload: false,
                showPreview: false,
                allowedFileTypes: ['pdf'],
                previewFileType: 'pdf',
                previewFileIcon: '<i class="fa fa-file"></i>',
            });

            $(newField).on('change', (fileSelected) => {
                const selectedFile = fileSelected.target.files[0];
                const documentTitle = $(`#lesson-document-${documentNumber}-title`);
                if (documentTitle.val() === '') {
                    let fileName = selectedFile.name;
                    if (selectedFile.type === 'application/pdf') {
                        fileName = fileName.substring(0, fileName.lastIndexOf('.'));
                    }
                    documentTitle.val(fileName);
                }
            });
        });
    };

    return my;
}(Postlogin || {}));
